import React from 'react';
import { Redirect, generatePath, useLocation } from 'react-router';

import { Web } from 'src/shared/constants/FeatureFlag';
import { useGetProjectsQuery } from 'src/shared/graphql/generated';
import { useIsEmbed, useTreatment } from 'src/shared/hooks';
import { useClearGlobalStorageUpload } from 'src/shared/hooks/useGlobalStorage';
import { Route } from 'src/shared/route';
import { isEnabled } from 'src/shared/telemetry/featureFlag';

import { useHomeownerAppContext } from '../../hooks/useHomeownerAppContext';
import { DesignerLandingPage } from '../DesignerLandingPage/DesignerLandingPage';
import { EmbeddedDesignerLandingPage } from '../DesignerLandingPage/EmbeddedDesignerLandingPage';

import { LoggedInHome } from './LoggedInHome';

const Home = () => {
  const { loggedIn } = useHomeownerAppContext();
  const location = useLocation();

  const isEmbed = useIsEmbed();
  const { data, loading: projectsLoading } = useGetProjectsQuery({
    skip: !loggedIn || isEmbed,
  });
  const projects = data?.projects?.slice() || [];
  const mostRecentProject = projects.sort((a, b) => b.id - a.id)[0];

  const isNewProjectUiEnabled = isEnabled(useTreatment(Web.NEW_PROJECT_UI));

  const projectRedirectPath = mostRecentProject
    ? generatePath(Route.HOMEOWNER_APP_PROJECT.path, {
        projectId: mostRecentProject.id,
      })
    : Route.HOMEOWNER_APP_NEW_PROJECT.path;

  useClearGlobalStorageUpload();

  // NOTE: the logged-in version of the home page isn't currently supported at
  // all in the embedded experience, so we always want to show the landing page
  if (isEmbed) return <EmbeddedDesignerLandingPage />;

  if (projectsLoading) return null;

  // If the user is logged in and the new project UI is enabled, redirect to
  // projects
  if (loggedIn && isNewProjectUiEnabled)
    return (
      <Redirect
        to={{ pathname: projectRedirectPath, search: location.search }}
      />
    );

  return loggedIn ? <LoggedInHome /> : <DesignerLandingPage />;
};

export { Home };
